import request from '@/utils/request'

// 查询权益卡列表
export function listBusinessEquityCard(query) {
  return request({
    url: '/business/businessEquityCard/list',
    method: 'get',
    params: query
  })
}

// 查询权益卡详细
export function getBusinessEquityCard(id) {
  return request({
    url: '/business/businessEquityCard/' + id,
    method: 'get'
  })
}

// 新增权益卡
export function addBusinessEquityCard(data) {
  return request({
    url: '/business/businessEquityCard',
    method: 'post',
    data: data
  })
}

// 修改权益卡
export function updateBusinessEquityCard(data) {
  return request({
    url: '/business/businessEquityCard',
    method: 'put',
    data: data
  })
}

// 删除权益卡
export function delBusinessEquityCard(id) {
  return request({
    url: '/business/businessEquityCard/' + id,
    method: 'delete'
  })
}

// 状态修改
export function changeStatus(data ) {
  return request({
    url: '/business/businessEquityCard/changeStatus',
    method: 'put',
    data: data
  })
}


// 权益卡审核
export function equityCardAudit(data) {
  return request({
    url: '/business/businessEquityCard/audit',
    method: 'put',
    data: data
  })
}

// 线下购买权益卡
export function offLineBuy(data) {
  return request({
    url: '/order/orderEquityCard/systemOffLineBuy',
    method: 'post',
    data: data
  })
}

// 查询会员权益卡列表
export function equityCardList(query) {
  return request({
    url: '/business/businessEquityCard/list',
    method: 'get',
    params: query
  })
}

export function getAllEquityCardList(param) {
  return request({
    url: '/business/businessEquityCard/getAllList',
    method: 'GET',
    params: param
  })
}
